import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const FOOTER_BG =
  "https://images.pexels.com/photos/1381722/pexels-photo-1381722.jpeg?auto=compress&cs=tinysrgb&w=2000";

const NAV_KEYS = ["home", "about", "portfolio", "market", "philosophy", "contact"];

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const handleNav = (key) => {
    const el = document.getElementById(key);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-white/5"
    >
      <div className="absolute inset-0">
        <img
          src={FOOTER_BG}
          alt="Dubai skyline at night"
          className="w-full h-full object-cover opacity-25"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#0A0A0A]/90" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <img
            src="/brand/brokers-lounge-logo-transparent.png"
            alt="Brokers Lounge"
            className="h-20 md:h-24 w-auto object-contain opacity-80 -ml-2"
            loading="lazy"
          />
          <p className="mt-6 text-[#A1A1AA] max-w-md leading-relaxed">
            {t.footer.tag}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">{t.footer.nav}</div>
          <ul className="space-y-3">
            {NAV_KEYS.map((k) => (
              <li key={k}>
                <button
                  data-testid={`footer-nav-${k}`}
                  onClick={() => handleNav(k)}
                  className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors"
                >
                  {t.nav[k]}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">{t.contact.office}</div>
          <div className="space-y-2 text-sm text-[#A1A1AA]">
            <div>{t.contact.office_addr}</div>
            <div dir="ltr">{t.contact.phone_value}</div>
            <div dir="ltr">{t.contact.email_value}</div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#71717A]">
          <div>
            © {year} Brokers Lounge. {t.footer.rights}
          </div>
          <div className="tracking-[0.2em] uppercase">Dubai · UAE</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
